/**
 * WHENEVER ATELIER — US Product Detail Page Controller
 * Handles gallery sync, color swatches, size validation, sticky mobile
 */

document.addEventListener("DOMContentLoaded", function () {
  const reco = document.querySelector("[data-recommendations-url]");
  if (reco) {
    fetch(reco.dataset.recommendationsUrl)
      .then(r => r.ok ? r.text() : "")
      .then(html => {
        if (!html) return;
        const fresh = new DOMParser().parseFromString(html, "text/html").querySelector(".section-gap");
        if (fresh) reco.replaceWith(fresh);
      })
      .catch(() => {});
  }
});

document.addEventListener("DOMContentLoaded", initPDP);

function initPDP() {
  const esc = WHENEVER_STORE.escapeHtml;
  const urlParams = new URLSearchParams(window.location.search);
  const handle = (window.location.pathname.match(/\/products\/([\w-]+)/)||[])[1] || urlParams.get("handle") || "";

  const product = WHENEVER_DATA.products.find(p => p.handle === handle);
  if (!product) return;

  // Active PDP state
  let selectedColor = product.colors[0];
  let selectedSize = null; // Do NOT auto-select size (Rule Section 6.3)

  renderProductInfo(product);
  renderGallery(selectedColor.images);
  renderSwatches(product);
  renderSizes(product);
  updateAddToCartBtn();
  initStickyMobile(product);
  initFancybox();
  initStickyBuybox();

  function renderProductInfo(prod) {
    const titleEl = document.getElementById("pdpTitle");
    const priceEl = document.getElementById("pdpPrice");
    const comparePriceEl = document.getElementById("pdpComparePrice");
    const proofLineEl = document.getElementById("pdpProofLine");
    const breadcrumbCategoryEl = document.getElementById("pdpBreadcrumbCategory");
    const breadcrumbTitleEl = document.getElementById("pdpBreadcrumbTitle");

    if (titleEl) titleEl.textContent = prod.title;
    if (priceEl) priceEl.textContent = WHENEVER_STORE.formatMoney(prod.price);
    if (comparePriceEl) {
      if (prod.compareAtPrice) {
        comparePriceEl.textContent = WHENEVER_STORE.formatMoney(prod.compareAtPrice);
        comparePriceEl.style.display = "inline";
      } else {
        comparePriceEl.style.display = "none";
      }
    }
    if (proofLineEl && prod.proofLine) proofLineEl.textContent = prod.proofLine;

    // Breadcrumb
    const cat = WHENEVER_DATA.categories && WHENEVER_DATA.categories.find(c => c.id === prod.category && c.id !== "all" && c.id !== "frontpage");
    if (breadcrumbCategoryEl && cat) {
      breadcrumbCategoryEl.textContent = cat.name;
      breadcrumbCategoryEl.href = cat.url;
    }
    if (breadcrumbTitleEl) breadcrumbTitleEl.textContent = prod.title;
  }

  function renderGallery(images) {
    const galleryEl = document.getElementById("pdpGallery");
    if (!galleryEl) return;

    galleryEl.innerHTML = images.map((img, idx) => `
      <div class="gallery-item" data-index="${idx}" role="button" tabindex="0" aria-label="Enlarge image ${idx + 1} of ${images.length}">
        <img src="${esc(img)}" alt="${esc(product.title)} - View ${idx + 1}" loading="${idx === 0 ? 'eager' : 'lazy'}" ${idx === 0 ? 'fetchpriority="high"' : ''} />
      </div>
    `).join("");

    // Attach click and keyboard handlers to open Fancybox
    galleryEl.querySelectorAll(".gallery-item").forEach(item => {
      item.addEventListener("click", function () {
        const idx = parseInt(this.dataset.index, 10);
        openFancybox(images, idx);
      });
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          const idx = parseInt(this.dataset.index, 10);
          openFancybox(images, idx);
        }
      });
    });
  }

  function renderSwatches(prod) {
    const container = document.getElementById("pdpSwatches");
    const label = document.getElementById("pdpColorLabel");
    if (!container) return;

    if (label) label.textContent = selectedColor.name;

    container.innerHTML = prod.colors.map(c => `
      <button type="button" class="swatch-btn ${c.slug === selectedColor.slug ? 'active' : ''}" 
              data-slug="${esc(c.slug)}" 
              style="background-color: ${c.code ? esc(c.code) : 'transparent'};"
              aria-label="Color ${esc(c.name)}"
              aria-pressed="${c.slug === selectedColor.slug ? 'true' : 'false'}">
      </button>
    `).join("");

    container.querySelectorAll(".swatch-btn").forEach(btn => {
      btn.addEventListener("click", function () {
        const slug = this.dataset.slug;
        const found = prod.colors.find(c => c.slug === slug);
        if (found && found.slug !== selectedColor.slug) {
          selectedColor = found;
          if (label) label.textContent = selectedColor.name;

          container.querySelectorAll(".swatch-btn").forEach(b => {
            b.classList.remove("active");
            b.setAttribute("aria-pressed", "false");
          });
          this.classList.add("active");
          this.setAttribute("aria-pressed", "true");
          renderGallery(selectedColor.images);

          // Re-evaluate size availability for newly selected color
          renderSizes(prod);
          updateAddToCartBtn();
        }
      });
    });
  }

  function syncSizeLabels() {
    const label = document.getElementById("pdpSizeLabel");
    const stickySizeBtn = document.getElementById("stickySizeBtn");
    const stickySpan = stickySizeBtn ? stickySizeBtn.querySelector("span") : null;
    const defaultStickyLabel = (stickySizeBtn && stickySizeBtn.dataset.defaultLabel) || (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.selectSizeLabel) || "Size";
    const selectSizeText = (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.selectSizeCta) || document.getElementById("pdpSizeGroup")?.dataset?.selectSizeLabel || "Select a size";

    if (selectedSize) {
      if (label) label.textContent = selectedSize;
      if (stickySpan) stickySpan.textContent = `Size: ${selectedSize}`;
    } else {
      if (label) label.textContent = selectSizeText;
      if (stickySpan) stickySpan.textContent = defaultStickyLabel;
    }
  }

  function renderSizes(prod) {
    const container = document.getElementById("pdpSizes");
    const sizeGroupEl = document.getElementById("pdpSizeGroup");
    const stickySizeBtn = document.getElementById("stickySizeBtn");

    if (prod.isOneSize) {
      if (sizeGroupEl) sizeGroupEl.style.display = "none";
      if (stickySizeBtn) stickySizeBtn.hidden = true;
      selectedSize = (prod.sizes && prod.sizes[0]) || "One Size";
      updateAddToCartBtn();
      return;
    }

    if (!container) return;
    if (sizeGroupEl) sizeGroupEl.style.display = "flex";
    if (stickySizeBtn) stickySizeBtn.hidden = false;

    const bySize = {};
    (selectedColor.variants || []).forEach(v => {
      bySize[v.size] = v;
    });

    if (selectedSize && !(bySize[selectedSize] && bySize[selectedSize].available)) {
      selectedSize = null;
    }
    syncSizeLabels();

    container.innerHTML = prod.sizes.map(sz => {
      const v = bySize[sz];
      const isOOS = !v || !v.available;
      const isSelected = selectedSize === sz;

      return `
        <button type="button" 
                class="size-pill-btn ${isSelected ? 'active' : ''} ${isOOS ? 'out-of-stock' : ''}" 
                data-size="${esc(sz)}"
                aria-pressed="${isSelected ? 'true' : 'false'}"
                ${isOOS ? 'disabled aria-disabled="true"' : ''}>
          ${esc(sz)}
        </button>
      `;
    }).join("");

    container.querySelectorAll(".size-pill-btn:not(.out-of-stock)").forEach(btn => {
      btn.addEventListener("click", function () {
        selectedSize = this.dataset.size;
        container.querySelectorAll(".size-pill-btn").forEach(b => {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });
        this.classList.add("active");
        this.setAttribute("aria-pressed", "true");

        syncSizeLabels();
        updateAddToCartBtn();
      });
    });
  }

  function updateAddToCartBtn() {
    const ctaBtns = document.querySelectorAll(".pdp-add-to-bag-btn");
    const anyAvailable = !!(selectedColor && selectedColor.variants && selectedColor.variants.some(v => v.available));

    ctaBtns.forEach(btn => {
      if (!anyAvailable) {
        btn.textContent = (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.soldOut) || "Sold out";
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        btn.classList.add("disabled");
      } else if (!selectedSize) {
        btn.textContent = (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.selectSizeCta) || "Select a Size";
        btn.disabled = false;
        btn.setAttribute("aria-disabled", "true");
        btn.classList.add("disabled");
      } else {
        btn.textContent = (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.addToBag) || "Add to Bag";
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
        btn.classList.remove("disabled");
      }
    });

    const stickySizeBtn = document.getElementById("stickySizeBtn");
    if (stickySizeBtn) {
      if (!anyAvailable) {
        stickySizeBtn.disabled = true;
        stickySizeBtn.setAttribute("aria-disabled", "true");
      } else {
        stickySizeBtn.disabled = false;
        stickySizeBtn.removeAttribute("aria-disabled");
      }
    }
  }



  /* --------------------------------------------------------------------------
     Sticky Mobile Bar & Add to Bag Dispatch
     -------------------------------------------------------------------------- */
  function initStickyMobile(prod) {
    const stickySizeBtn = document.getElementById("stickySizeBtn");
    if (stickySizeBtn) {
      stickySizeBtn.addEventListener("click", function () {
        const sizeGroup = document.getElementById("pdpSizeGroup");
        if (sizeGroup) {
          sizeGroup.scrollIntoView({ behavior: "smooth", block: "center" });
          const firstPill = sizeGroup.querySelector(".size-pill-btn:not([disabled]):not(.out-of-stock)");
          if (firstPill) {
            firstPill.focus({ preventScroll: true });
          } else {
            if (!sizeGroup.hasAttribute("tabindex")) sizeGroup.setAttribute("tabindex", "-1");
            sizeGroup.focus({ preventScroll: true });
          }
        }
      });
    }

    const stickyBar = document.getElementById("mobileStickyBar");
    const mainAtc = document.getElementById("pdpAddToCart");
    if (stickyBar && mainAtc) {
      let ticking = false;
      const syncStickyBar = () => {
        ticking = false;
        const footer = document.querySelector(".site-footer, footer");
        const isPastAtc = mainAtc.getBoundingClientRect().bottom < 0;
        const isAboveFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
        stickyBar.classList.toggle("active", isPastAtc && isAboveFooter);
      };
      window.addEventListener("scroll", () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(syncStickyBar);
        }
      }, { passive: true });
      syncStickyBar();
    }

    // Add To Bag actions
    const addBtns = document.querySelectorAll(".pdp-add-to-bag-btn");
    addBtns.forEach(btn => {
      btn.addEventListener("click", async function (e) {
        e.preventDefault();
        if (btn.classList.contains("loading")) return;
        if (!selectedSize) {
          showToast((WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.selectSize) || "");
          const sizeGroup = document.getElementById("pdpSizeGroup");
          if (sizeGroup) {
            sizeGroup.scrollIntoView({ behavior: "smooth", block: "center" });
            const firstPill = sizeGroup.querySelector(".size-pill-btn:not([disabled]):not(.out-of-stock)");
            if (firstPill) {
              firstPill.focus({ preventScroll: true });
            } else {
              if (!sizeGroup.hasAttribute("tabindex")) sizeGroup.setAttribute("tabindex", "-1");
              sizeGroup.focus({ preventScroll: true });
            }
          }
          return;
        }

        const variant = prod.isOneSize
          ? (selectedColor && selectedColor.variants && selectedColor.variants[0])
          : (selectedColor && selectedColor.variants && selectedColor.variants.find(v => v.size === selectedSize));
        if (!variant || !variant.variantId || !variant.available) {
          showToast((WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.selectSize) || "");
          return;
        }

        addBtns.forEach(b => {
          b.classList.add("loading");
          b.setAttribute("aria-busy", "true");
        });

        const res = await WHENEVER_STORE.addItem({
          productHandle: prod.handle,
          title: prod.title,
          colorName: selectedColor.name,
          colorSlug: selectedColor.slug,
          size: (variant && variant.size) || selectedSize,
          price: variant.price || prod.price,
          variantId: variant.variantId,
          image: (selectedColor.images && selectedColor.images[0]) || "",
          quantity: 1
        });

        addBtns.forEach(b => {
          b.classList.remove("loading");
          b.removeAttribute("aria-busy");
        });
        if (!res || !res.success) {
          const errMsg = (res && res.error) || (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.addToBagError) || "";
          if (errMsg) showToast(errMsg);
          return;
        }

        const addedTpl = (WHENEVER_DATA.i18n && WHENEVER_DATA.i18n.addedToBag) || "";
        let toastMsg = addedTpl.replace("{{ title }}", prod.title);
        if (selectedColor.slug === "default") {
          toastMsg = toastMsg.replace("{{ color }} / ", "").replace(" ({{ color }})", "").replace("{{ color }}", "");
        } else {
          toastMsg = toastMsg.replace("{{ color }}", selectedColor.name);
        }
        toastMsg = toastMsg.replace("{{ size }}", selectedSize);
        showToast(toastMsg);

        if (typeof openCartDrawer === "function") {
          openCartDrawer();
        }
      });
    });
  }

  /* --------------------------------------------------------------------------
     Fancybox Lightbox Gallery Controller
     -------------------------------------------------------------------------- */
  let currentFancyboxImages = [];
  let currentFancyboxIndex = 0;

  function initFancybox() {
    const modal = document.getElementById("pdpFancybox");
    const backdrop = document.getElementById("fancyboxBackdrop");
    const closeBtn = document.getElementById("fancyboxClose");
    const prevBtn = document.getElementById("fancyboxPrev");
    const nextBtn = document.getElementById("fancyboxNext");

    if (!modal) return;
    if (backdrop) backdrop.addEventListener("click", closeFancybox);
    if (closeBtn) closeBtn.addEventListener("click", closeFancybox);
    if (prevBtn) prevBtn.addEventListener("click", () => navigateFancybox(-1));
    if (nextBtn) nextBtn.addEventListener("click", () => navigateFancybox(1));

    window.addEventListener("keydown", function (e) {
      if (!modal.classList.contains("active")) return;
      if (e.key === "Escape") closeFancybox();
      if (currentFancyboxImages && currentFancyboxImages.length > 1) {
        if (e.key === "ArrowLeft") navigateFancybox(-1);
        if (e.key === "ArrowRight") navigateFancybox(1);
      }
    });
  }

  function openFancybox(images, index) {
    const modal = document.getElementById("pdpFancybox");
    if (!modal) return;

    currentFancyboxImages = images || [];
    currentFancyboxIndex = (index >= 0 && index < currentFancyboxImages.length) ? index : 0;

    updateFancyboxContent();
    modal.classList.add("active");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("fancybox-active");
    const closeBtn = document.getElementById("fancyboxClose");
    if (typeof focusOverlay === "function") {
      focusOverlay(closeBtn);
    } else if (closeBtn) {
      closeBtn.focus();
    }
  }

  function closeFancybox() {
    const modal = document.getElementById("pdpFancybox");
    if (!modal) return;

    modal.classList.remove("active");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("fancybox-active");
    if (typeof restoreOverlayFocus === "function") {
      restoreOverlayFocus();
    }
  }

  function navigateFancybox(delta) {
    if (!currentFancyboxImages || currentFancyboxImages.length <= 1) return;
    const len = currentFancyboxImages.length;
    currentFancyboxIndex = (currentFancyboxIndex + delta + len) % len;
    updateFancyboxContent();
  }

  function updateFancyboxContent() {
    const imgEl = document.getElementById("fancyboxImg");
    const counterEl = document.getElementById("fancyboxCounter");
    const titleEl = document.getElementById("fancyboxTitle");
    const colorEl = document.getElementById("fancyboxColor");
    const thumbsContainer = document.getElementById("fancyboxThumbs");
    const prevBtn = document.getElementById("fancyboxPrev");
    const nextBtn = document.getElementById("fancyboxNext");

    const isMulti = !!(currentFancyboxImages && currentFancyboxImages.length > 1);
    if (prevBtn) prevBtn.hidden = !isMulti;
    if (nextBtn) nextBtn.hidden = !isMulti;
    if (thumbsContainer) thumbsContainer.hidden = !isMulti;

    if (imgEl && currentFancyboxImages[currentFancyboxIndex]) {
      imgEl.src = currentFancyboxImages[currentFancyboxIndex];
      imgEl.alt = `${product.title} - View ${currentFancyboxIndex + 1}`;
    }

    if (counterEl) {
      const cur = String(currentFancyboxIndex + 1).padStart(2, "0");
      const tot = String(Math.max(1, currentFancyboxImages ? currentFancyboxImages.length : 1)).padStart(2, "0");
      counterEl.textContent = `${cur} / ${tot}`;
    }

    if (titleEl) titleEl.textContent = product.title;
    if (colorEl) colorEl.textContent = (selectedColor && selectedColor.name) || "";

    if (thumbsContainer) {
      if (!isMulti) {
        thumbsContainer.innerHTML = "";
      } else {
        const hadThumbFocus = !!(document.activeElement && thumbsContainer.contains(document.activeElement));
        thumbsContainer.innerHTML = currentFancyboxImages.map((src, idx) => `
          <div class="fancybox-thumb-item ${idx === currentFancyboxIndex ? 'active' : ''}" data-index="${idx}" role="button" tabindex="0" aria-label="Go to image ${idx + 1}" ${idx === currentFancyboxIndex ? 'aria-current="true"' : ''}>
            <img src="${esc(src)}" alt="Thumbnail ${idx + 1}" />
          </div>
        `).join("");

        thumbsContainer.querySelectorAll(".fancybox-thumb-item").forEach(item => {
          item.addEventListener("click", function () {
            currentFancyboxIndex = parseInt(this.dataset.index, 10);
            updateFancyboxContent();
          });
          item.addEventListener("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              const idx = parseInt(this.dataset.index, 10);
              currentFancyboxIndex = idx;
              updateFancyboxContent();
            }
          });
        });

        if (hadThumbFocus) {
          const activeThumb = thumbsContainer.querySelector(`.fancybox-thumb-item[data-index="${currentFancyboxIndex}"]`);
          if (activeThumb) activeThumb.focus();
        }
      }
    }
  }

  /* --------------------------------------------------------------------------
     Sticky Buybox Parent Unblocker
     -------------------------------------------------------------------------- */
  function initStickyBuybox() {
    const buybox = document.querySelector(".pdp-buybox");
    if (!buybox) return;

    let el = buybox.parentElement;
    while (el && el !== document.documentElement) {
      const style = window.getComputedStyle(el);
      if (style.overflowX === "hidden" || style.overflowY === "hidden") {
        el.style.overflow = "visible";
      }
      el = el.parentElement;
    }
  }
}
